/**
 * Actor Types
 *
 * Origin classification for actions in the system. Used in activity-event
 * audit logs to record where a call chain started. Authorization is NOT
 * carried on actorType — that lives on user-aggregate / event role arrays.
 *
 * Values:
 * - `request` — HTTP request entry point. `actorId` carries the request id
 *   for log correlation. Upgraded to `user` inside `userActions` once the
 *   request is authenticated.
 * - `user` — programmatic context bound to an identified user (post-auth,
 *   inside `userActions`, or post-creation onboarding flows).
 * - `agent` — AI agent / porter LLM workflow steps.
 * - `job` — background job, scheduler, or queue processor.
 * - `application` — programmatic platform-originated work (transactional
 *   senders, platform-initiated entity creation).
 */

import { z } from "zod";

export const ActorType = {
  REQUEST: "request",
  USER: "user",
  AGENT: "agent",
  JOB: "job",
  APPLICATION: "application",
} as const;

export const ActorTypeSchema = z.enum(ActorType);

export type ActorType = z.infer<typeof ActorTypeSchema>;
